import React, { useEffect, useState } from 'react';
import DictTagsCategoryService from '../../../services/dict/DictTagsCategoryService';
import AddDictTagsCategory from './AddDictTagsCategory';
import { withTranslation, WithTranslation } from 'react-i18next';

type Props = WithTranslation;

const ShowDictTagsCategory: React.FC<Props> = ({ t }) => {
    const [dictTagsCategories, setDictTagsCategories] = useState<any[]>([]);
    const [modalVisible, setModalVisible] = useState(false);

    useEffect(() => {
        loadDictTagsCategories();
    }, []);

    const loadDictTagsCategories = () => {
        DictTagsCategoryService.getDictTagsCategory()
            .then(response => {
                setDictTagsCategories(response.data);
            })
            .catch(error => {
                console.error('Error loading dict tags categories:', error);
            });
    };

    const handleAddCategory = (newCategory: any) => {
        setDictTagsCategories(prevCategories => [...prevCategories, newCategory]);
        setModalVisible(false);
    };

    return (
        <div>
            <button onClick={() => setModalVisible(true)}>{t("buttons.add_category")}</button>
            <table style={{ borderCollapse: 'collapse' }} className="fixed-table">
                <thead>
                    <tr>
                        <th>{t("table.id")}</th>
                        <th>{t("table.name")}</th>
                    </tr>
                </thead>
                <tbody>
                    {dictTagsCategories.map(category => (
                        <tr key={category.id}>
                            <td>{category.id}</td>
                            <td>{category.name}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            {modalVisible && (
                <AddDictTagsCategory
                    dictTagsCategory={dictTagsCategories}
                    onAddCategory={handleAddCategory}
                />
            )}
        </div>
    );
};

export default withTranslation("global")(ShowDictTagsCategory);